
/**
 * 常用字符串验证
 * @class StringUtilsClass
 */
class StringUtilsClass {
    constructor(str) {
        this.string = str;
    }
    // 校验字串是否为空
    isEmpty() {
        return this.string === null || this.string === undefined || (this.string + '').length === 0;
    }

    // 校验字串是否不为空
    isNotEmpty() {
        return !this.isEmpty();
    }

    // 判断是否为手机号
    isMobilePhone() {
        let myreg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
        return myreg.test(this.string);
    }

    // 判断是否为电话号码   验证规则：区号+号码，区号以0开头，3位或4位  号码由7位或8位数字组成  区号与号码之间可以无连接符，也可以“-”连接
    isTelPhone() {
        let myreg = /^0\d{2,3}-?\d{7,8}$/;
        return myreg.test(this.string);
    }

    // 判断是否为邮箱
    isEmail() {
        // let myreg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); 
		let myreg = /^\w{6,18}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
        return myreg.test(this.string);
    }

    // 判断是否为身份证
    isIDcard() {
        let myreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        return myreg.test(this.string);
    }
	
	//判断是否位护照/(P\d{7})|(G\d{8})/
	isPassport(){
		let myreg = /(P\d{7})|(G\d{8})/;
		return myreg.test(this.string);
	}

}

export default function (str) {
    return new StringUtilsClass(str);
}